import { Skeleton } from '@/components/ui/skeleton';

// Tab content loading skeleton
export function TabLoadingSkeleton() {
  return (
    <div className="space-y-4 p-4">
      <div className="flex items-center gap-3">
        <Skeleton className="h-10 w-10 rounded-full bg-zinc-800" />
        <div className="space-y-2">
          <Skeleton className="h-4 w-32 bg-zinc-800" />
          <Skeleton className="h-3 w-24 bg-zinc-800" />
        </div>
      </div>
      <Skeleton className="h-32 w-full rounded-lg bg-zinc-800" />
      <div className="grid grid-cols-2 gap-4">
        <Skeleton className="h-24 rounded-lg bg-zinc-800" />
        <Skeleton className="h-24 rounded-lg bg-zinc-800" />
      </div>
      <Skeleton className="h-48 w-full rounded-lg bg-zinc-800" />
    </div>
  );
}

// Card loading skeleton
export function CardLoadingSkeleton() {
  return (
    <div className="bg-zinc-900 border border-zinc-800 rounded-lg p-4 space-y-3">
      <div className="flex justify-between items-center">
        <Skeleton className="h-5 w-24 bg-zinc-800" />
        <Skeleton className="h-6 w-16 rounded-full bg-zinc-800" />
      </div>
      <Skeleton className="h-16 w-full rounded bg-zinc-800" />
      <div className="flex gap-2">
        <Skeleton className="h-8 flex-1 rounded bg-zinc-800" />
        <Skeleton className="h-8 flex-1 rounded bg-zinc-800" />
      </div>
    </div>
  );
}

// Table loading skeleton
export function TableLoadingSkeleton({ rows = 5 }) {
  return (
    <div className="space-y-2">
      <div className="flex gap-4 p-3 bg-zinc-800/50 rounded-t-lg">
        <Skeleton className="h-4 w-20 bg-zinc-700" />
        <Skeleton className="h-4 w-16 bg-zinc-700" />
        <Skeleton className="h-4 w-24 bg-zinc-700" />
        <Skeleton className="h-4 flex-1 bg-zinc-700" />
      </div>
      {[...Array(rows)].map((_, i) => (
        <div key={i} className="flex gap-4 p-3 border-b border-zinc-800">
          <Skeleton className="h-4 w-20 bg-zinc-800" />
          <Skeleton className="h-4 w-16 bg-zinc-800" />
          <Skeleton className="h-4 w-24 bg-zinc-800" />
          <Skeleton className="h-4 flex-1 bg-zinc-800" />
        </div>
      ))}
    </div>
  );
}

// Chart loading skeleton
export function ChartLoadingSkeleton() {
  return (
    <div className="bg-zinc-900 border border-zinc-800 rounded-lg p-4">
      <div className="flex justify-between mb-4">
        <Skeleton className="h-5 w-32 bg-zinc-800" />
        <div className="flex gap-2">
          <Skeleton className="h-6 w-12 rounded bg-zinc-800" />
          <Skeleton className="h-6 w-12 rounded bg-zinc-800" />
        </div>
      </div>
      <div className="h-64 flex items-end gap-1">
        {[...Array(20)].map((_, i) => (
          <Skeleton 
            key={i} 
            className="flex-1 bg-zinc-800" 
            style={{ height: `${Math.random() * 80 + 20}%` }}
          />
        ))}
      </div>
    </div>
  );
}

export default TabLoadingSkeleton;
